module.exports = __webpack_public_path__ + "2795642be5423993148bb5f4bfb9a6b9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/marc-selfie.jpg
 ** module id = 385
 ** module chunks = 0
 **/